<template>
  <b-row
    v-if="!isLoading"
    class="justify-content-center m-0"
    align-v="center"
    :style="{ height: '100%' }"
  >
    <div>
      <b-row class="box-content">
        <!-- column left -->
        <b-col class="box-content__left">
          <div v-if="!isInvalidToken">
            <ContentVerifiedEmail :email="email" />
          </div>
          <div v-else>
            <div class="mb-u6 text__title">Invalid Token</div>
            <div class="mb-u6 text__description">Please sign in and resend verify email again.</div>
          </div>
        </b-col>
        <!-- column right -->
        <b-col class="box-content__right">
          <div class="d-flex justify-content-center">
            <b-img class="img-right" :src="require(`@/assets/email-1.jpg`)" fluid />
          </div>
        </b-col>
      </b-row>
    </div>
  </b-row>
</template>

<script>
import jwt from 'jsonwebtoken';
import User from '@/models/User';
import { userInfoMixin } from '@/mixins/userInfoMixin';
import ContentVerifiedEmail from './components/ContentVerifiedEmail';
import { amplitudeMixin } from '@/mixins/amplitudeMixin';
import { useAuth } from '@/composables/useAuth';
const { loadUserData } = useAuth();
export default {
  components: {
    ContentVerifiedEmail
  },

  mixins: [userInfoMixin, amplitudeMixin],

  data: () => ({
    email: 'EMAIL NOT FOUND',
    isLoading: false,
    isInvalidToken: false
  }),

  computed: {
    confirmationToken() {
      return this.$route.query.token;
    }
  },

  async created() {
    await this.init();
  },

  methods: {
    async init() {
      if (this.user && this.user.confirmed) {
        this.email = this.user.email;

        return;
      }

      if (!this.confirmationToken) {
        this.isInvalidToken = true;
        this.$_amplitudeMixin_onCheck({
          Token: this.confirmationToken,
          IsInvalidToken: this.isInvalidToken,
          Message: 'Invalid Token'
        });
        return;
      }

      this.isLoading = true;

      const result = await jwt.decode(this.confirmationToken);

      this.email = result.email;

      try {
        await User.api().verifyEmail(this.confirmationToken);

        await loadUserData();

        this.$_amplitudeMixin_onCheck({
          Token: this.confirmationToken,
          IsInvalidToken: this.isInvalidToken
        });
      } catch (error) {
        console.error(error);
        if (error.response?.data?.message === 'invalid token') {
          this.isInvalidToken = true;
          this.$_amplitudeMixin_onCheck({
            Token: this.confirmationToken,
            IsInvalidToken: this.isInvalidToken,
            Message: 'Invalid Token'
          });
        }
      }

      this.isLoading = false;
    }
  }
};
</script>

<style scoped>
.text__title {
  font-weight: 700;
  font-size: 26.6px;
  line-height: 32px;
  color: #3b3e66;
}

.text__description {
  font-weight: 400;
  font-size: 15.2px;
  line-height: 22px;
  color: #3b3e66;
}

.box-content {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 50px 10px;
}

.box-content__right .img-right {
  max-width: 400px;
}

@media only screen and (max-width: 767px) {
  .box-content {
    flex-direction: column-reverse;
    gap: 20px 25px;
    padding: 5%;
  }

  .box-content__right .img-right {
    min-width: 250px;
    width: 80%;
  }
}

@media only screen and (min-width: 768px) and (max-width: 991.98px) {
  .box-content {
    gap: 50px 0;
    padding: 5%;
  }

  .box-content__right .img-right {
    min-width: 250px;
    width: 100%;
  }
}
</style>
